/* eslint-disable no-unreachable */
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  applicantsActions,
  createProfileActions,
  permissionActions,
} from '../_actions';
import '../assets/styles/applicants.css';
import ReactModal from 'react-modal';
import ReactPaginate from 'react-paginate';
import { getApplicantStatus } from '_utils/utils';
import { toast } from 'react-toastify';
import moment from 'moment';
import { ReactComponent as Warning } from 'assets/icons/applicant-warning-icon.svg';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { handleErrorResponse, formatDate } from '_helpers/helpers';
import { authHeader } from '_helpers';
import PropTypes from 'prop-types';
import { dateTimeConstants } from '_constants';

ReactModal.setAppElement('#app');

// To format the phone number
function formatPhoneNumber(s) {
  const s2 = ('' + s).replace(/\D/g, '');
  const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : m[1] + '-' + m[2] + '-' + m[3];
}

const ApplicationStatuses = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
};

class FormerEmployedApplicants extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      statusUpdating: false,
      statusOpen: false,
      flag: true,
      removeApplicant: '',
      removeAction: '',
      selected: '',
      _page: 0,
      searchStatus: false,
      clearFilter: false,
      applicant_info: [],
      resultData: [],
      filterResult: false,
      order: true,
      sort: 'date',
      nameOrder: false,
      emailOrder: false,
      phoneOrder: false,
      dateOrder: true,
      areaOrder: false,
      certOrder: false,
      orderAll: 'asc',
      dateSort: 'desc',
      loader: '',
      keySearch: '',
      validMsg: '',
      borderError: '',
      filterOption: '',
      currentStatusUpdate: null,
      paginationLoading: false,
      editableNote: { note: '', id: '' },
      noteEditMode: false,
      isNoteLoading: false,
      results_per_page: localStorage.getItem('results_per_page')
        ? parseInt(localStorage.getItem('results_per_page'))
        : 30,

      applicantHash: '',
      crews: [],
      applicant_details: null,
      applicantStatus: '',
      crew: '',
      whoSelected: '',
      whoRejected: '',
      rejectionReason: '',
      date: moment(),
      time: moment(),
      applicantCurrentStatus: {},
      applicantHasAnyInterviewForms: false,
    };
    this.lastCreatedNoteRef = React.createRef();
    this.viewDetails = this.viewDetails.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.chooseAction = this.chooseAction.bind(this);
    this.validate = this.validate.bind(this);
    this.updateApplicantStatus = this.updateApplicantStatus.bind(this);
    this.archived = this.archived.bind(this);
    this.hired = this.hired.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateNotes = this.updateNotes.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.emailFilter = this.emailFilter.bind(this);
    this.filter = this.filter.bind(this);
    this.sorting = this.sorting.bind(this);

    this.removeStatusCloseModal = this.removeStatusCloseModal.bind(this);
    this.onChangeUpdateApplicantStatus =
      this.onChangeUpdateApplicantStatus.bind(this);
    this.onChangeUpdateApplicantDate =
      this.onChangeUpdateApplicantDate.bind(this);
    this.onChangeUpdateApplicantTime =
      this.onChangeUpdateApplicantTime.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.onEditNoteClick = this.onEditNoteClick.bind(this);
    this.onCancelAddEditNote = this.onCancelAddEditNote.bind(this);
    this.onChangeEditNote = this.onChangeEditNote.bind(this);
    this.deleteApplicantNote = this.deleteApplicantNote.bind(this);
  }

  onChangeUpdateApplicantStatus(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  onChangeUpdateApplicantDate(date) {
    this.setState({ date });
  }

  onChangeUpdateApplicantTime(time) {
    this.setState({ time });
  }

  removeStatusCloseModal() {
    this.setState({ statusOpen: false, applicantStatus: '' });
    this.setState({
      whoRejected: '',
      rejectionReason: '',
      whoSelected: '',
      crew: '',
    });
  }

  onChangeSelect(selected, type) {
    this.setState({ [type]: selected.value });
    if (type === 'whoSelected') {
      this.setState({ whoRejected: '', rejectionReason: '' });
    } else if (type === 'whoRejected') {
      this.setState({ whoSelected: '', crew: '' });
    } else if (
      (type === 'applicantStatus' && selected.value === 1) ||
      selected.value === 3 ||
      selected.value === 4
    ) {
      this.setState({
        whoRejected: '',
        rejectionReason: '',
        whoSelected: '',
        crew: '',
      });
    }
  }

  updateApplicantStatus() {
    const {
      applicantHash,
      applicantStatus,
      crew,
      rejectionReason,
      date,
      time,
    } = this.state;

    const isConfirmNeeded = [
      ApplicationStatuses.WAS_HIRED,
      ApplicationStatuses.NOT_SELECTED_ARCHIVE,
      ApplicationStatuses.DO_NOT_HIRE_ARCHIVE,
    ].includes(applicantStatus);

    if (
      (applicantStatus === ApplicationStatuses.NOT_SELECTED_ARCHIVE ||
        applicantStatus === ApplicationStatuses.DO_NOT_HIRE_ARCHIVE) &&
      !rejectionReason?.length
    ) {
      return toast.error("The  notes on reason for rejection can't be empty.");
    }

    this.setState({ statusUpdating: true });

    let data = new FormData();
    data.append('hash', applicantHash);
    data.append('action', applicantStatus);
    data.append('former_employee', 1);

    if (isConfirmNeeded) {
      if (applicantStatus === ApplicationStatuses.WAS_HIRED) {
        data.append(
          'crew_id',
          crew ? crew : this.props?.user?.profile?.data?.crew_identifier_id,
        );
      } else if (
        applicantStatus === ApplicationStatuses.NOT_SELECTED_ARCHIVE ||
        applicantStatus === ApplicationStatuses.DO_NOT_HIRE_ARCHIVE
      ) {
        data.append('rejected_reason', rejectionReason);
      }
      data.append('performed_by', this.props?.user?.profile?.data?.id);
      data.append(
        'status_change_date',
        date && time
          ? `${moment(date).format(dateTimeConstants.ISO_DATE_FORMAT)} ${moment(
              time,
            ).format('hh:mm:ss')}`
          : null,
      );
    }

    this.props
      .dispatch(applicantsActions.removeApplicant(data))
      ?.then((res) => {
        if (res?.success) {
          this.removeStatusCloseModal();
          this.setState({
            statusUpdating: false,
          });
          this.componentDidMount();
          this.setState({ statusUpdating: false });
        } else {
          handleErrorResponse(res);
          this.setState({ statusUpdating: false });
        }
      });
  }

  componentDidMount() {
    this.props.dispatch(
      applicantsActions.getFormerEmployedApplicants(
        this.state.results_per_page,
      ),
    );
    this.props.dispatch(permissionActions.getPermission());
    this.props.dispatch(createProfileActions.getAll());
  }

  componentWillReceiveProps(nextProps) {
    const { applicants } = nextProps;

    // Fetching Applicant list
    if (applicants.items) {
      let dataResult;
      let appInf = [];
      // for filter results
      if (
        this.props.param !== '' &&
        this.props.from === 'filter' &&
        this.state.clearFilter === false
      ) {
        dataResult = applicants.items.data;
      } else {
        dataResult = applicants.items.data.data;
      }
      if (dataResult?.length) {
        if (dataResult.length > 0) {
          dataResult.map((item, index) => {
            appInf[item.hash] = item.applicant_info;
            this.setState((state) => ({
              applicant_info: { ...state.applicant_info, ...appInf },
            }));
          });
        }
      } else {
        applicants.items.data = [];
      }
      this.setState({
        resultData: Array.isArray(applicants.items.data)
          ? { data: applicants.items.data }
          : applicants.items.data,
      });
      if (
        Array.isArray(applicants.items.data) &&
        applicants.items.data.length
      ) {
        // Filters
        this.setState({
          filterResult: true,
        });
      } else {
        this.setState({
          filterResult: false,
        });
      }
    }
  }

  componentDidUpdate() {
    if (this.lastCreatedNoteRef.current) {
      this.lastCreatedNoteRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  async updateNotes(noteDetails) {
    this.setState({ isNoteLoading: true });
    const userPermissions = this.props.permission.permissions.data;

    if (!userPermissions.includes('Update Applicant Note'))
      return toast.error("You don't have permission to add/edit notes!");

    const applicantHash = this.state.noteEditMode
      ? noteDetails.applicant_hash
      : noteDetails.hash;
    const { id, note } = this.state.editableNote;

    let data = new FormData();
    data.append('applicant_hash', applicantHash);
    data.append('notes', note);
    data.append('note_id', this.state.noteEditMode ? id : '');
    data.append('former_employee', 1);

    let sortedApplicantsFormData = new FormData();
    if (this.state.hasSorted || this.state.filterOption) {
      sortedApplicantsFormData.append('sort', this.state.sort);
      sortedApplicantsFormData.append(
        'order',
        this.state.order ? 'desc' : 'asc',
      );
      sortedApplicantsFormData.append('type', this.state.filterOption);
    }

    let filteredApplicantsReqData = new FormData();
    filteredApplicantsReqData.append('startDate', this.state.startDate || '');
    filteredApplicantsReqData.append('endDate', this.state.endDate || '');
    filteredApplicantsReqData.append('variable1', this.state.variable1 || '');
    filteredApplicantsReqData.append('variable2', this.state.variable2 || '');

    const res = await this.props.dispatch(applicantsActions.updateNote(data));

    if (res?.data?.success) {
      toast.success(res.data.message);
      this.setState({
        noteEditMode: false,
        editableNote: {
          ...this.state.editableNote,
          id: '',
          note: '',
        },
      });

      if (this.props.from === 'filter') {
        this.props.dispatch(
          applicantsActions.sortFilterApplicant(
            data,
            this.state.sort,
            this.state.order ? 'desc' : 'asc',
          ),
        );
        this.setState({ isNoteLoading: false });
        return;
      }

      if (this.state.hasSorted || this.state.filterOption) {
        this.props.dispatch(
          await applicantsActions.searchApplicants(sortedApplicantsFormData),
        );
      } else {
        await this.props.dispatch(
          applicantsActions.getFormerEmployedApplicants(
            this.state.results_per_page,
          ),
        );
      }

      this.setState({ isNoteLoading: false });
    } else {
      const parsedRes = JSON.parse(res?.error);
      if (parsedRes.message) {
        Object.keys(parsedRes.message).forEach((key) => {
          parsedRes.message[key].forEach((message) => {
            toast.error(message);
          });
        });
      }
    }
  }

  async deleteApplicantNote(note) {
    this.setState({ isNoteLoading: true });
    const { id } = note;
    const data = new FormData();
    data.append('note_id', id);
    data.append('former_employee', 1);
    const res = await this.props.dispatch(
      applicantsActions.deleteNote(data, id),
    );
    if (res?.data?.success) {
      toast.success(res.data.message);
      this.setState({ isNoteLoading: false });

      let sortedApplicantsFormData = new FormData();
      if (this.state.hasSorted || this.state.filterOption) {
        sortedApplicantsFormData.append('sort', this.state.sort);
        sortedApplicantsFormData.append(
          'order',
          this.state.order ? 'desc' : 'asc',
        );
        sortedApplicantsFormData.append('type', this.state.filterOption);
      }

      if (this.props.from === 'filter') {
        this.props.dispatch(
          applicantsActions.sortFilterApplicant(
            data,
            this.state.sort,
            this.state.order ? 'desc' : 'asc',
          ),
        );
        this.setState({ isNoteLoading: false });
        return;
      }

      if (this.state.hasSorted || this.state.filterOption) {
        this.props.dispatch(
          await applicantsActions.searchApplicants(sortedApplicantsFormData),
        );
      } else {
        await this.props.dispatch(
          applicantsActions.getFormerEmployedApplicants(
            this.state.results_per_page,
          ),
        );
      }
    } else {
      this.setState({ isNoteLoading: false });
      const parsedRes = JSON.parse(res?.error);
      if (parsedRes.message) {
        Object.keys(parsedRes.message).forEach((key) => {
          parsedRes.message[key].forEach((message) => {
            toast.error(message);
          });
        });
      }
    }
  }

  // Close the popup
  statusCloseModal() {
    this.setState({
      statusOpen: false,
      statusUpdating: false,
      selectedApplicantNoInterviewForms: false,
    });
  }

  // Selecting remove option
  chooseAction(action) {
    const status = {
      denied: 0,
      received: 1,
      hire: 2,
      inreview: 3,
      offered: 4,
      donthire: 10,
      remove: 0,
    };
    this.setState({
      removeAction: action,
      selected: action,
      currentStatusUpdate: status[action],
      validMsg: '',
      borderError: '',
    });
  }

  // To Archieved applicants page
  archived() {
    this.props.archived();
  }

  // To Hired applicants page
  hired() {
    this.props.hired();
  }

  // To detail page of applicant
  viewDetails(hash) {
    this.props.viewDetails(hash);
  }

  // To email applicant page
  emailFilter() {
    this.props.emailFilter();
  }

  // To filter page
  filter() {
    this.props.filter();
  }

  onEditNoteClick(note) {
    this.setState({
      noteEditMode: true,
      editableNote: {
        ...this.state.editableNote,
        id: note.id,
        note: note.notes,
      },
    });
  }

  onCancelAddEditNote() {
    this.setState({ editableNote: { note: '', id: '' }, noteEditMode: false });
  }

  onChangeEditNote(value) {
    this.setState({
      editableNote: { ...this.state.editableNote, note: value },
    });
  }

  sorting(sort, e) {
    this.setState({
      order: !this.state.order,
      sort,
      loader: '',
      hasSorted: true,
    });
    if (sort === 'name') {
      this.setState({
        nameOrder: !this.state.nameOrder,
        emailOrder: false,
        phoneOrder: false,
        areaOrder: false,
        certOrder: false,
        jobStatusOrder: false,
        dateOrder: false,
      });
    }
    if (sort === 'email') {
      this.setState({
        nameOrder: false,
        emailOrder: !this.state.emailOrder,
        phoneOrder: false,
        areaOrder: false,
        certOrder: false,
        jobStatusOrder: false,
        dateOrder: false,
      });
    }
    if (sort === 'phone') {
      this.setState({
        nameOrder: false,
        emailOrder: false,
        phoneOrder: !this.state.phoneOrder,
        areaOrder: false,
        certOrder: false,
        jobStatusOrder: false,
        dateOrder: false,
      });
    }
    if (sort === 'area') {
      this.setState({
        nameOrder: false,
        emailOrder: false,
        phoneOrder: false,
        areaOrder: !this.state.areaOrder,
        certOrder: false,
        jobStatusOrder: false,
        dateOrder: false,
      });
    }
    if (sort === 'cert') {
      this.setState({
        nameOrder: false,
        emailOrder: false,
        phoneOrder: false,
        areaOrder: false,
        certOrder: !this.state.certOrder,
        jobStatusOrder: false,
        dateOrder: false,
      });
    }
    if (sort === 'date') {
      this.setState({
        nameOrder: false,
        emailOrder: false,
        phoneOrder: false,
        areaOrder: false,
        certOrder: false,
        jobStatusOrder: false,
        dateOrder: !this.state.dateOrder,
      });
    }
    if (sort === 'job_status') {
      this.setState({
        nameOrder: false,
        emailOrder: false,
        phoneOrder: false,
        areaOrder: false,
        certOrder: false,
        dateOrder: false,
        jobStatusOrder: !this.state.jobStatusOrder,
      });
    }
    let order;
    if (this.state.order) {
      order = 'asc';
    } else {
      order = 'desc';
    }
    this.setState({ orderAll: order, dateSort: order });
    if (this.props.param !== '' && this.props.from === 'filter') {
      let data = new FormData();
      data.append('startDate', this.state.startDate);
      data.append('endDate', this.state.endDate);
      data.append('variable1', this.state.variable1);
      data.append('variable2', this.state.variable2);
      data.append('former_employee', 1);
      this.props.dispatch(
        applicantsActions.sortFilterApplicant(data, sort, order),
      );
    } else {
      let data = new FormData();
      if (this.state.keySearch) {
        data.append('keyword', this.state.keySearch);
      }
      data.append('sort', sort);
      data.append('order', order);
      data.append('results_per_page', this.state.results_per_page);
      data.append('former_employee', 1);
      this.props.dispatch(applicantsActions.searchApplicants(data));
    }
  }

  validate() {
    let err = false;
    if (this.state.removeAction === '') {
      return true;
    }
  }

  handleSearch() {
    this.setState({
      searchStatus: true,
    });
    let { filterOption } = this.state;
    let data = new FormData();
    data.append('type', filterOption);
    data.append('keyword', this?.state?.keySearch);
    data.append('results_per_page', this.state.results_per_page);
    data.append('former_employee', 1);

    if (
      this.props.param !== '' &&
      this.props.from === 'filter' &&
      this?.state?.keySearch !== ''
    ) {
      data.append('startDate', this.props.param.start_date);
      data.append('endDate', this.props.param.end_date);
      data.append('variable1', this.props.param.var1);
      data.append('variable2', this.props.param.var2);
      this.props.dispatch(applicantsActions.filterApplicants(data));
    } else {
      data.append('sort', this.state.sort);
      if (this.state.sort === 'date') {
        data.append('order', this.state.dateSort);
      } else {
        data.append('order', this.state.orderAll);
      }
      this.props.dispatch(applicantsActions.searchApplicants(data));
      this.setState({ clearFilter: true });
    }
  }

  sendMail(email) {
    this.props.sendMail(email);
  }

  handlePageChange(page) {
    if (!page || this.state.filterResult) return;
    let current = page.selected + 1;
    let method,
      sortVariable = '';
    if (this.state.sort !== '' && this.state.sort !== 'date') {
      sortVariable =
        '&sort=' + this.state.sort + '&order=' + this.state.orderAll;
    } else if (this.state.sort !== '' && this.state.sort === 'date') {
      sortVariable =
        '&sort=' + this.state.sort + '&order=' + this.state.dateSort;
    }
    let { filterOption } = this.state;
    if (filterOption) {
      sortVariable = `${sortVariable}&type=${filterOption}`;
    }

    let data = this.state.resultData;

    let requestOptions = {};
    if (
      data.next_page_url?.indexOf('search') !== -1 ||
      data.last_page_url?.indexOf('search') !== -1
    ) {
      method = 'POST';
      let bdata = new FormData();
      bdata.append('keyword', this.state.keySearch);
      bdata.append('former_employee', 1);

      requestOptions = {
        method: method,
        headers: authHeader(),
        body: bdata,
      };
    } else {
      method = 'GET';
      requestOptions = {
        method: method,
        headers: authHeader(),
      };
    }
    let _url =
      (data.next_page_url || data.last_page_url) &&
      (data.next_page_url || data.last_page_url).replace(
        /(page=)[0-9]{1,}/,
        'page=' + current,
      );

    this.setState({
      paginationLoading: true,
      _page: page.selected,
    });
    fetch(
      _url + '&results_per_page=' + this.state.results_per_page + sortVariable,
      requestOptions,
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        let appInf = {};
        if (data?.data?.data.length > 0) {
          let dataResult = data.data.data || [];
          dataResult.map((item, index) => {
            appInf[item.hash] =
              item.applicant_info && item.applicant_info !== 'null'
                ? item.applicant_info
                : '';
          });
        }
        this.setState(
          {
            applicant_info: appInf,
          },
          () => {
            this.setState({ resultData: data.data, paginationLoading: false });
          },
        );
      })
      .catch((err) => {
        this.setState({
          paginationLoading: false,
        });
      });
  }
  render() {
    let nameClass, emailClass, phoneClass, dateClass, jobStatusClass;
    const { applicants } = this.props;
    const reslts_per = [5, 10, 15, 20, 30, 50, 100];

    const tooltip = (
      <Tooltip id='tooltip'>
        <strong style={{ color: '#fff' }}>No interview forms added.</strong>
      </Tooltip>
    );

    if (applicants.items) {
      let dataResult = [];
      if (
        this.props.param !== '' &&
        this.props.from === 'filter' &&
        this.state.clearFilter === false
      ) {
        dataResult = applicants.items.data;
      } else {
        if (applicants.items.data.length === 0) {
          dataResult = applicants.items.data;
        } else {
          dataResult = applicants.items.data.data;
        }
      }
      if (this.state.sort === 'name') {
        if (this.state.nameOrder && this.state.sort === 'name') {
          nameClass = 'sort-arrow desc';
        } else {
          nameClass = 'sort-arrow asc';
        }
        emailClass = phoneClass = dateClass = jobStatusClass = 'sort-arrow';
      }
      if (this.state.sort === 'email') {
        if (this.state.emailOrder && this.state.sort === 'email') {
          emailClass = 'sort-arrow desc';
        } else {
          emailClass = 'sort-arrow asc';
        }
        nameClass = phoneClass = dateClass = jobStatusClass = 'sort-arrow';
      }
      if (this.state.sort === 'phone') {
        if (this.state.phoneOrder && this.state.sort === 'phone') {
          phoneClass = 'sort-arrow desc';
        } else {
          phoneClass = 'sort-arrow asc';
        }
        nameClass = emailClass = dateClass = jobStatusClass = 'sort-arrow';
      }
      if (this.state.sort === 'date') {
        if (this.state.dateOrder && this.state.sort === 'date') {
          dateClass = 'sort-arrow desc';
        } else {
          dateClass = 'sort-arrow asc';
        }
        nameClass = emailClass = phoneClass = jobStatusClass = 'sort-arrow';
      }
      if (this.state.sort === 'area') {
        if (this.state.areaOrder && this.state.sort === 'area') {
        } else {
        }
        nameClass =
          emailClass =
          dateClass =
          phoneClass =
          jobStatusClass =
            'sort-arrow';
      }
      if (this.state.sort === 'cert') {
        nameClass =
          emailClass =
          dateClass =
          phoneClass =
          jobStatusClass =
            'sort-arrow';
      }
      if (this.state.sort === 'job_status') {
        if (this.state.jobStatusOrder && this.state.sort === 'job_status') {
          jobStatusClass = 'sort-arrow desc';
        } else {
          jobStatusClass = 'sort-arrow asc';
        }
        nameClass = emailClass = phoneClass = 'sort-arrow';
      }

      if (dataResult) {
        const applicantsList = this.state.resultData?.data;

        return (
          <div className='applicants_container applicant_listing'>
            <div className='page_title'>
              <h1>Former Employed Applicants</h1>
            </div>

            <div
              className={
                'applicants_inner_head inner_head inner_head_mob ' +
                (this.state.filterResult ? 'hide-filters' : '')
              }
            >
              <div className='col-xs-12 col-sm-12 col-md-6'></div>

              <div className='col-xs-12 col-sm-12 col-md-6'>
                <div className='right_inputs_wrapper'>
                  <div className='results_per_page_wrapper'>
                    Results per page
                    <select
                      value={this.state.results_per_page}
                      onChange={($event) => {
                        var value = $event.target.value;
                        this.setState(
                          {
                            results_per_page: value,
                          },
                          () => {
                            this.handlePageChange.call(this, {
                              selected: this.state._page,
                            });
                          },
                        );

                        localStorage.setItem('results_per_page', value);
                      }}
                    >
                      {reslts_per?.map((item, index) => {
                        return (
                          <option key={'results_per_page' + index} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className='applicant_search_wrapper'>
                    <input
                      type='text'
                      className='applicant_search'
                      value={this.state.keySearch}
                      name='keyword'
                      placeholder='Search...'
                      onChange={(e) =>
                        this.setState({ keySearch: e.target.value })
                      }
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          this.handleSearch(); // Trigger search on Enter key press
                        }
                      }}
                      autoComplete='off'
                    />

                    <button
                      style={{ height: '38px', marginLeft: '5px' }}
                      onClick={this.handleSearch}
                      className='button'
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className='inner_container col-lg-12 applicants_list_page'
              id='applicants_inner'
            >
              <div className='applicants_list' id='applicants_list'>
                <div className='appln_list_header'>
                  <div
                    className='list_item_head appln_name'
                    onClick={this.sorting.bind(this, 'name')}
                  >
                    Name
                    <span className={nameClass} />
                  </div>
                  <div
                    className='list_item_head appln_email'
                    onClick={this.sorting.bind(this, 'email')}
                  >
                    Email
                    <span className={emailClass} />
                  </div>
                  <div
                    className='list_item_head appln_phone'
                    onClick={this.sorting.bind(this, 'phone')}
                  >
                    Cell Phone
                    <span className={phoneClass} />
                  </div>
                  <div
                    className='list_item_head appln_date'
                    onClick={this.sorting.bind(this, 'date')}
                  >
                    Date
                    <span className={dateClass} />
                  </div>
                  <div className='list_item_head appln_area'>Area</div>
                  <div className='list_item_head'>Cert. Status</div>
                  <div
                    className='list_item_head appln_status'
                    onClick={this.sorting.bind(this, 'job_status')}
                  >
                    Status
                    <span className={jobStatusClass} />
                  </div>
                  <div className='list_item_head appln_status'>
                    Archived Status
                  </div>
                  <div className='list_item_head appln_status'></div>
                </div>
                <div className='items-wrapper'>
                  {this.state.paginationLoading && (
                    <div className='items-overlay' />
                  )}
                  {applicantsList?.map((item, index) => {
                    return (
                      <div
                        className='applicant_item'
                        key={index + 25}
                        data-test='df'
                      >
                        {item.status === 3 && (
                          <span className='aplication-status-indicator'>
                            <img
                              src={
                                require('../assets/images/review.png').default
                              }
                              className='in-review-ico'
                              alt='review'
                            />
                          </span>
                        )}
                        {item.status === 1 && (
                          <span className='aplication-status-indicator'>
                            <img
                              src={
                                require('../assets/images/tick_round.png')
                                  .default
                              }
                              alt='tick'
                            />
                          </span>
                        )}
                        {item.status === 4 && (
                          <span className='offer-posted aplication-status-indicator'>
                            <img
                              src={
                                require('../assets/images/offeredposition.svg')
                                  .default
                              }
                              alt='Offered Position'
                            />
                          </span>
                        )}

                        <div className='basic_info'>
                          <div className='appln_name'>
                            {item.first_name + ' ' + item.last_name}
                            {item.reapplied_status == 1 && item.status == 1 && (
                              <span className='badge'>NEW</span>
                            )}
                            {item.interview_form_count === 0 && (
                              <span className='no-interview-form-icon'>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={tooltip}
                                >
                                  <Warning />
                                </OverlayTrigger>
                              </span>
                            )}
                          </div>
                          <div className='appln_email'>
                            {item.email_address ? (
                              <a
                                onClick={(event) => {
                                  event.stopPropagation();
                                }}
                                className='phone_email_link'
                                href={`mailto:${item.email_address}`}
                                target='_top'
                              >
                                {item.email_address}
                              </a>
                            ) : (
                              ''
                            )}
                          </div>
                          <div className='appln_phone'>
                            {item.phone_number ? (
                              <a
                                onClick={(event) => {
                                  event.stopPropagation();
                                }}
                                className='phone_email_link'
                                href={`tel:${item.phone_number}`}
                                target='_top'
                              >
                                {formatPhoneNumber(item.phone_number)}
                              </a>
                            ) : (
                              ''
                            )}
                          </div>
                          <div className='appln_date'>
                            {formatDate(item.date)}
                          </div>
                          <div className='appln_area'>{item.area}</div>
                          <div className='appln_cert_status'>
                            {item.cert_status}
                          </div>
                          <div className='appln_status'>
                            {getApplicantStatus[item.status]}
                          </div>
                          <div className='appln_status'>
                            {item.do_not_hire && (
                              <span className='fs-badge fs-badge-red'>
                                Do Not Hire
                              </span>
                            )}
                            {item.not_selected && (
                              <span className='fs-badge fs-badge-orange'>
                                Not Selected
                              </span>
                            )}
                            {!(item.do_not_hire || item.not_selected) && (
                              <>NA</>
                            )}
                          </div>

                          <div className='applicant-actions'>
                            <>
                              <Link to={'/applicant-view/' + item.hash}>
                                <img
                                  alt='view'
                                  src={
                                    require('../assets/images/view.png').default
                                  }
                                  className='applicant-card-action-button'
                                />
                              </Link>
                            </>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {!this.state.filterResult &&
                    this.state.resultData.data?.length > 0 && (
                      <div className='customised-pagination'>
                        <ReactPaginate
                          previousLabel={''}
                          nextLabel={''}
                          breakLabel={'...'}
                          breakClassName={'break-me'}
                          pageCount={this.state.resultData.last_page}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={this.handlePageChange.bind(this)}
                          containerClassName={'pagination'}
                          subContainerClassName={'pages pagination'}
                          activeClassName={'active'}
                        />
                      </div>
                    )}
                  {(!this.state.resultData.data ||
                    !this.state.resultData.data.length) && (
                    <div key='noResult' className='applicant_item light-box'>
                      <div className='basic_info'>
                        <p className='noResult'>No search results were found</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      }
    }

    // Showing loader
    return (
      <div className='applicants_container applicant_listing'>
        <div className='page_title'>
          <h1>Former Employed Applicants</h1>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { applicants, permission, user } = state;
  return {
    applicants,
    permission,
    user,
  };
}

const connectedHomePage = connect(mapStateToProps)(FormerEmployedApplicants);
export { connectedHomePage as FormerEmployedApplicants };

FormerEmployedApplicants.propTypes = {
  dispatch: PropTypes.func.isRequired,
  applicants: PropTypes.object,
  permission: PropTypes.object,
  user: PropTypes.object,
  archived: PropTypes.func.isRequired,
  hired: PropTypes.func.isRequired,
  viewDetails: PropTypes.func.isRequired,
  sendMail: PropTypes.func.isRequired,
  emailFilter: PropTypes.func.isRequired,
  filter: PropTypes.func.isRequired,
  param: PropTypes.object,
  from: PropTypes.string.isRequired,
};
